import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import './BreadcrumbNav.css';

/**
 * BreadcrumbNav - Breadcrumb navigation component
 * 
 * @param {Object} props
 * @param {Array} props.breadcrumbs - Array of { label, level, onClick }
 */
const BreadcrumbNav = ({ breadcrumbs = [] }) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  const items = breadcrumbs.map((crumb, index) => {
    const isLast = index === breadcrumbs.length - 1;
    const hasOnClick = crumb.onClick && !isLast;
    
    return {
      title: index === 0 ? (
        <span
          className={isLast ? 'breadcrumb-active' : 'breadcrumb-link'}
          onClick={hasOnClick ? crumb.onClick : undefined}
          style={{
            cursor: hasOnClick ? 'pointer' : 'default',
          }}
        >
          <HomeOutlined style={{ marginRight: '4px' }} />
          {crumb.label}
        </span>
      ) : (
        <span
          className={isLast ? 'breadcrumb-active' : 'breadcrumb-link'}
          onClick={hasOnClick ? crumb.onClick : undefined}
          style={{
            cursor: hasOnClick ? 'pointer' : 'default',
          }}
        >
          {crumb.label}
        </span>
      ),
    };
  });

  return (
    <div className="breadcrumb-nav">
      <Breadcrumb items={items} />
    </div>
  );
};

export default BreadcrumbNav;

